import { basePalette } from './palette.js';

var overrides = {
    MuiCssBaseline: {
        '@global': {
            '*::-webkit-scrollbar': {
                width: '12px',
            },
            '*::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(167,167,167,1)',
                border: '2px solid rgba(245, 245, 245, 1)',
                borderRadius: '8px',
            },
            '*::-webkit-scrollbar-track': {
                backgroundColor: 'rgba(245, 245, 245, 1)',
                borderRadius: '0px',
            },
        },
    },
    MuiSwitch: {
        checked: {},
        track: {},
        switchBase: {
            '&$checked': {
                color: basePalette.success.main,
                '& + $track': {
                    background: basePalette.success.light,
                },
            },
        },
    },
};

export { overrides };
//# sourceMappingURL=overrides.js.map
